import BaseStore from './BaseStore'

export class SystemUsageStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'system_usages'
  }
}

export default new SystemUsageStore()


// WEBPACK FOOTER //
// ./src/stores/SystemUsageStore.js